import { BaseSelect, Button, TextArea, TextInput } from '@app/components';
import { StyledForms } from '@app/components/styled/form/Form';
import React, { forwardRef } from 'react';
import { CatalogOverrides } from './CatalogOverrides';
import { useModal } from '@app/hooks/useModal';
import { TagSelect } from '@app/components/form/selects/features/TagSelect';
import { PromotionSelect } from '@app/components/form/selects/features/PromotionSelect';
import { InputFile, InputFileRef } from '@app/components/form/InputFile';
import { ShopSelect } from '@app/components/form/selects/features/ShopSelect';
import { createColumnHelper } from '@tanstack/react-table';
import { ITag } from '@app/common';
import { ConnectorSelect } from '@app/components/form/selects/features/ConnectorSelect';
import { StepSelect } from '@app/components/form/selects/features/StepSelect';
import { OptionSelect } from '@app/components/form/selects/features/OptionSelect';
import { FormSection } from '@app/components/styled/form/FormSection';

const modalId = 'catalog';

const columnHelper = createColumnHelper<{ tag: ITag }>();

const selectedColumns = [
  columnHelper.display({
    id: 'name',
    header: () => (
      <BaseSelect.ListHeaderItem width="100%">
        Nom
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => (
      <BaseSelect.ListItemCol width="100%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {info.row.original.tag.name}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    ),
  }),
];

export const CatalogForm = forwardRef<any>((_, ref: React.ForwardedRef<InputFileRef>) => {
  const modal = useModal(modalId);

  return (
    <StyledForms.Form>

      <InputFile name="image" ref={ref} />

      <FormSection.Section>
        <FormSection.Title>Informations générales</FormSection.Title>
        <FormSection.Content>
          <TextInput
            name="name"
            label="Nom"
            autoCapitalize="none" />

          <TextArea
            name="ticketInfos.bottomLines"
            label="Informations bas de ticket" />

          <ConnectorSelect
            name='catalogToConnectors'
            transform={{
              value: (item) => ({ connector: item }),
              accessor: (item) => (item.connector?._id),
              display: (item) => (item?.connector?.name)
            }}
            isMultiple />

          <ShopSelect name='catalogToShops' isMultiple />

        </FormSection.Content>
      </FormSection.Section>

      <FormSection.Section>
        <FormSection.Title>Composition du catalogue</FormSection.Title>
        <FormSection.Content>

          <TagSelect
            name='catalogToTags'
            selectedColumns={selectedColumns}
            transform={{
              value: (item) => ({ tag: item }),
              accessor: (item) => (item.tag?._id),
              display: (item) => (item?.tag?.name)
            }}
            isMultiple />


          <PromotionSelect
            name="catalogToPromotions"
            onBuildFilters={(search) => ({
              $and: [
                {
                  name: {
                    $contains: search
                  },
                },
                {
                  code: {
                    $isNull: true
                  }
                }
              ]
            })}
            transform={{
              value: (item) => ({ promotion: item }),
              accessor: (item) => (item.promotion?._id),
              display: (item) => (item?.promotion?.name)
            }}
            isMultiple />

          <Button title="J'ajoute mes produits & menus" onPress={() => modal.open()} />

        </FormSection.Content>
      </FormSection.Section>

      <FormSection.Section>
        <FormSection.Title>Personnalisation avancée</FormSection.Title>
        <FormSection.Content>

          <StepSelect
            name="catalogToExcludedSteps"
            label='Etapes à exclure'
            transform={{
              value: (item) => ({ step: item }),
              accessor: (item) => (item.step?._id),
              display: (item) => (item?.step?.name)
            }}
            isMultiple />

          <OptionSelect
            name="catalogToExcludedOptions"
            label='Options à exclure'
            transform={{
              value: (item) => ({ option: item }),
              accessor: (item) => (item.option?._id),
              display: (item) => (item?.option?.name)
            }}
            isMultiple />

        </FormSection.Content>
      </FormSection.Section>

      <CatalogOverrides modalId={modalId} />
    </StyledForms.Form>
  );
});
